import { buildCsv, formatCsvDecimal } from "./csv";
import type { TopRow, ArticleSeriesBucket, StockValueSnapshot } from "@/api/dashboard";

// CSV-Builder fuer die Auswertungs-Panels (Welle 2, #10). Reine Funktionen — der Download
// laeuft ueber ExportCsvButton/downloadCsv. Zahlen mit Punkt-Dezimal (siehe lib/csv.ts).
// W3 (#9): die Retouren-Liste liefert zwei Zusatzfelder (verkaufte Stück + Quote). Sie
// erscheinen NUR dann als Spalten, wenn die Daten sie enthalten (soldQty !== null) — sonst
// bliebe der CSV der Grundartikel- und Kategorie-Panels mit zwei dauerhaft leeren Spalten
// zurueck. Leere Quote (unter Mindestabsatz) bleibt eine leere Zelle, nicht "0".
export function buildTopCsv(rows: TopRow[]): string {
  const withReturns = rows.some((r) => r.soldQty !== null);
  const header = ["Bezeichnung", "Zusatz", "Stück", "Wert EUR", "Anteil %"];
  if (withReturns) header.push("Verkauft Stück", "Retouren-Quote %");
  return buildCsv(
    header,
    rows.map((r) => {
      const row = [r.label, r.sublabel, String(r.qty), formatCsvDecimal(r.value), formatCsvDecimal(r.pct)];
      if (withReturns) {
        row.push(
          r.soldQty === null ? "" : String(r.soldQty),
          r.returnRate === null ? "" : formatCsvDecimal(r.returnRate),
        );
      }
      return row;
    }),
  );
}

export function buildArticleSeriesCsv(buckets: ArticleSeriesBucket[], channels: string[]): string {
  const header = ["Zeitraum"];
  for (const ch of channels) {
    header.push(`${ch} Stück`, `${ch} Umsatz EUR`);
  }
  return buildCsv(
    header,
    buckets.map((b) => {
      const row = [b.label];
      for (const ch of channels) {
        const v = b.values[ch] ?? { qty: 0, revenue: 0 };
        row.push(String(v.qty), formatCsvDecimal(v.revenue));
      }
      return row;
    }),
  );
}

export function buildStockValueHistoryCsv(rows: StockValueSnapshot[]): string {
  return buildCsv(
    ["Datum", "Lagerwert EK EUR", "Bestand gesamt", "Grundartikel", "ohne EK-Preis"],
    rows.map((r) => [
      r.snapshot_date,
      formatCsvDecimal(r.total_value_ek),
      String(r.total_quantity),
      String(r.ga_count),
      String(r.ga_without_ek),
    ]),
  );
}
